/* eslint-disable react-hooks/exhaustive-deps */
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { getWorkScheduleAssignHistoriesList } from "../../../apis/work-schedule";
import Filters from "../../../components/Filters";
import Profile from "../../../components/Profile";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import { getParams } from "../../../utils/params";

const History = () => {
  const [fields] = useState([
    {
      title: '변경일',
      key: 'createdTime',
      type: 'date'
    },
    {
      title: '근무일정명',
      key: 'scheduleTitle'
    },
    {
      title: '직원',
      key: 'employeeIdx',
      onValue: (value) => {
        return (
          <Profile employeeIdx={value} />
        )
      }
    },
    {
      title: '기존 적용일',
      key: 'orgApplyStartDate'
    },
    {
      title: '현재 적용일',
      key: 'nowApplyStartDate'
    }
  ]);
  const [filters] = useState([
    {
      title: '조회기간',
      key: 'range.createdDate',
      type: 'customdatepicker'
    }
  ])

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      assignedAs: "person",
      range: {
        createdDate: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);


  const submit = (params) => {
    getWorkScheduleAssignHistoriesList(getParams(params))
      .then((res) => {
        setTotal(get(res, "data.total"));
        setList(get(res, "data.assignHistories"));
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false)
      });
  };

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        submit={handleSubmit}
      />
    </>
  );
};

export default History;
